import React from 'react'
import ProdIOOSumViewRow from './ProdIOOSumViewRow'
import ProdIOOSumGroupView from './ProdIOOSumGroupView';
import withView from '../../../../cmn/docAutomation/withView';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import FormSearchButton from '../../../../../library/form/components/FormSearchButton';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import FormWrapper from '../../../../../library/form/components/FormWrapper';
import { UiView, UiViewHeading, UiAction, UiViewContent } from "../../../../../library/layout/Index";
import FormCheckbox from '../../../../../library/form/components/FormCheckbox';

const ProdIOOSumView = (props) => {
    const { formObject, viewData } = props;
    const groupView = formObject?.childViewsV5?.groupView?.viewData || null;
    const groupsData = groupView?.groups || [];
    // const hasGroupedView = false;

    const showToggleGroupBtn = formObject.getFormData(null, "viewConfig", "showToggleGroupBtn");
    const hasGroupedView = formObject.getValueFromKey(showToggleGroupBtn, "val", "0") === "1" && groupsData.length > 0;

    const onGroupToggleClick = (value) => {
        const showToggleGroupBtn = formObject.getFormData(null, "viewConfig", "showToggleGroupBtn");
        const settingKey = formObject.getValueFromKey(showToggleGroupBtn, "dataList.settingKey", "");

        if(!settingKey) return;

        const action = {
            actionName: "prodComp",
            actionId: 'save',
            actionParam: {
                actionType: 'saveSetting',
                settingKey,
                settingValue: value
            }
        };

        formObject.onFormAction(action, null, "viewConfig");

        console.log("onGroupToggleClick", value, hasGroupedView, settingKey);
    }
    
    return (
        <>
            <UiView>
                <UiViewHeading>
                    <UiAction>
                        <span className="uiSpacerH5"><SarasTrans value="Group Summary" /></span>
                        <FormCheckbox formObject={formObject} headerKey="viewConfig"
                            onChange={onGroupToggleClick}
                            action={{ 
                                InputType: "onOff", paramName: "showToggleGroupBtn" 
                            }}
                        />
                    </UiAction>
                    <UiAction>
                        <span className="uiSpacerH5"><SarasTrans value="Step 1: Add Stock" /></span>
                        <FormButton formObject={formObject} headerKey="viewConfig" className="uiActionButton"
                            confirm="Do you want to Autogenerate?"
                            action={{ actionId: "new", 
                            paramName: "autoGeneratePlanBtn",
                            actionParam: {actionType : "autoGeneratePlanItems", pathKey:"OEXI"}, 
                            refreshMode:"self", excludePathKeys: 1 }}
                            text={<SarasTrans value="Auto Generate Plan" />}>
                        </FormButton>
                        <FormButton formObject={formObject} headerKey="viewConfig" className="uiActionButton "
                            action={{ actionId: "new", 
                            paramName: "addBOMBtn",
                            actionParam: {actionType : "addBOMItem", pathKey:"OEXI", 
                            viewKey:"addBOMItem"}, 
                            containerKey: "popup"
                            }}
                            text={<SarasTrans value="Add Stock from BOM" />}>
                        </FormButton>
                        <div className="uiSpacerH10"></div>
                        <FormWrapper customWrapper="" formObject={formObject} 
                            headerKey="viewConfig" action={{ paramName: "addAdhocBtn" }} >
                            <FormSearchButton formObject={formObject} headerKey='lineItemLink'
                                action={{ actionId: "new", 
                                loadEditorAfterAdd: 1,
                                actionParam: {actionType : "addItem", pathKey: "OEXI"}, 
                                refreshMode:"self", excludePathKeys: 1 }}
                                className='uiActionIconButton uiSpacerH10' placeholder="Barcode or Item Id"
                            />
                        </FormWrapper>
                        <div className="uiSpacerH10"></div>
                        <span className="uiSpacerH5"><SarasTrans value="Step 2: Inventory Action" /></span>
                        <FormButton formObject={formObject} headerKey="viewConfig" className="uiActionButton"
                            action={{ actionId: "new", 
                            paramName: "addReqStkBtn",
                            actionParam: {actionType : "requestItem", pathKey:"OREQ", viewKey:"addRequest"}, 
                            containerKey: "popup" }}
                            text={<SarasTrans value="Request Stock" />}>
                        </FormButton>
                        <FormButton formObject={formObject} headerKey="viewConfig" className="uiActionButton"
                            action={{ actionId: "new",
                            paramName: "addRetStkBtn", 
                            actionParam: {actionType : "returnInput", pathKey:"ORET", viewKey:"addReturn"}, 
                            containerKey: "popup" }}
                            text={<SarasTrans value="Return Stock" />}>
                        </FormButton>
                    </UiAction>
                </UiViewHeading>
                <UiViewContent>
                    <ul 
                        className={`uiListTable uiProductionTable ${hasGroupedView ? "uiGroupedView" : "uiRawDataView"}`}
                        style={{ minWidth: "1230px" }}>
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnLeft uiColumn130"></li>
                                <li className="uiColumnLeft uiColumn350"></li>
                                <li className="uiColumnLeft uiColumn50"></li>
                                <li className="uiColumnCenter uiColumn140 uiColumnGroupSplit"><SarasTrans value="Planning" /></li>
                                <li className="uiColumnCenter uiColumn280 uiColumnGroupSplit"><SarasTrans value="Controller Actions" /></li>
                                <li className="uiColumnCenter uiColumn210 uiColumnGroupSplit"><SarasTrans value="Worker Actions" /></li>
                                <li className="uiColumnLeft uiColumn100"></li>
                            </ul>
                            <ul>
                                <li className="uiColumnLeft uiColumn130"><SarasTrans value="Item ID" /></li>
                                <li className="uiColumnLeft uiColumn350"><SarasTrans value="Item" /></li>
                                <li className="uiColumnLeft uiColumn50"><SarasTrans value="Unit" /></li>
                                <li className="uiColumnRight uiColumnQty"><SarasTrans value="Required" /></li>
                                <li className="uiColumnRight uiColumnQty uiColumnGroupSplit"><SarasTrans value="Allocated" /></li>
                                <li className="uiColumnRight uiColumnQty"><SarasTrans value="Requested" /></li>
                                <li className="uiColumnRight uiColumnQty"><SarasTrans value="Received" /></li>
                                <li className="uiColumnRight uiColumnQty"><SarasTrans value="With Controller" /></li>
                                <li className="uiColumnRight uiColumnQty uiColumnGroupSplit"><SarasTrans value="Return" /></li>
                                <li className="uiColumnRight uiColumnQty"><SarasTrans value="With Worker" /></li>
                                <li className="uiColumnRight uiColumnQty"><SarasTrans value="Used" /></li>
                                <li className="uiColumnRight uiColumnQty uiColumnGroupSplit"><SarasTrans value="Waste" /></li>
                            </ul>
                        </li>
                        {hasGroupedView ? (
                            <ProdIOOSumGroupView groupsData={groupsData} viewRows={viewData} formObject={formObject} />
                        ) : (
                            Object.values(viewData ? viewData : {}).sort((a, b) => a.sortKey - b.sortKey).map((row, index) => (
                                <li key={index}><ProdIOOSumViewRow formObject={formObject} rowKey={row.rowKey} viewData={row} index={index + 1}/></li>
                            ))
                        )}
                    </ul>
                </UiViewContent>
            </UiView>
        </>
    )
}

export default withView(ProdIOOSumView, "prodIOSum", "prodIOSum");
